import {takeLatest, all} from "redux-saga/effects";
import { register_proceed } from "../actions";
import { GET_PRODUCTS, GET_PRODUCT_DETAILS,LOGOUT,LOGIN,REGISTER,REGISTER_PROCEED,FORGOT_PASSWORD } from "../actions/types";
import {handleGetProducts} from "./products"
import { handleGetProductDetails } from "./productDetails";
import { login,logout,registered_proceed,forgotPasswordHandler } from "./user";

export function* watcherSaga() {
    yield all([takeLatest(GET_PRODUCTS, handleGetProducts), 
        takeLatest(GET_PRODUCT_DETAILS, handleGetProductDetails),
        takeLatest(LOGOUT, logout),
        takeLatest(LOGIN, login),
        takeLatest(REGISTER_PROCEED, registered_proceed), 
        takeLatest(FORGOT_PASSWORD, forgotPasswordHandler), 
    
    
    ])

}